import React, { useEffect, useState } from 'react';
import PayrollLayout from '../../layouts/PayrollLayout';

export default function Settings() {
  const defaultConfig = {
    payroll_cycle: '',
    tax_slab: '',
    pf_rate: '',
    esi_rate: '',
    pay_date: '',
    enable_tds: false,
    auto_payslip_email: false,
    salary_components: {
      basic: false,
      hra: false,
      bonus: false,
    },
  };

  const [config, setConfig] = useState(defaultConfig);
  const [edit, setEdit] = useState(defaultConfig);

  useEffect(() => {
    // Simulated API call
    setTimeout(() => {
      const dummyConfig = {
        payroll_cycle: 'Monthly',
        tax_slab: '2024-25 Regime',
        pf_rate: 12,
        esi_rate: 0.75,
        pay_date: '28',
        enable_tds: true,
        auto_payslip_email: false,
        salary_components: {
          basic: true,
          hra: true,
          bonus: false,
        },
      };
      setConfig(dummyConfig);
      setEdit({ ...dummyConfig });
    }, 800);
  }, []);

  const handleChange = (field, value) => {
    setEdit({ ...edit, [field]: value });
  };

  const handleComponentToggle = (key) => {
    setEdit((prev) => ({
      ...prev,
      salary_components: {
        ...prev.salary_components,
        [key]: !prev.salary_components[key],
      },
    }));
  };

  const handleToggle = (field) => {
    setEdit({ ...edit, [field]: !edit[field] });
  };

  const handleSave = () => {
    alert('Settings saved (mock)');
    setConfig(edit);
  };

  const handleReset = () => {
    setEdit({ ...config });
  };


  return (
    <PayrollLayout title="Payroll Settings">
      <div className="bg-white dark:bg-gray-900 p-4 rounded-2xl font-poppins space-y-6">

        <div className="grid sm:grid-cols-2 gap-4">
          <div>
            <label className="block font-medium mb-1 dark:text-white">Payroll Cycle</label>
            <select
              value={edit.payroll_cycle}
              onChange={(e) => handleChange('payroll_cycle', e.target.value)}
              className="border dark:border-gray-700 dark:bg-black dark:text-white px-3 py-2 rounded w-full text-sm"
            >
              <option>Monthly</option>
              <option>Bi-weekly</option>
              <option>Weekly</option>
            </select>
          </div>

          <div>
            <label className="block font-medium mb-1 dark:text-white">Tax Slab</label>
            <input
              type="text"
              value={edit.tax_slab}
              onChange={(e) => handleChange('tax_slab', e.target.value)}
              className="border dark:border-gray-700 dark:bg-black dark:text-white px-3 py-2 rounded w-full text-sm"
            />
          </div>

          <div>
            <label className="block font-medium mb-1 dark:text-white">PF Rate (%)</label>
            <input
              type="number"
              value={edit.pf_rate}
              onChange={(e) => handleChange('pf_rate', parseFloat(e.target.value))}
              className="border dark:border-gray-700 dark:bg-black dark:text-white px-3 py-2 rounded w-full text-sm"
            />
          </div>

          <div>
            <label className="block font-medium mb-1 dark:text-white">ESI Rate (%)</label>
            <input
              type="number"
              value={edit.esi_rate}
              onChange={(e) => handleChange('esi_rate', parseFloat(e.target.value))}
              className="border dark:border-gray-700 dark:bg-black dark:text-white px-3 py-2 rounded w-full text-sm"
            />
          </div>

          <div>
            <label className="block font-medium mb-1 dark:text-white">Pay Date (of month)</label>
            <input
              type="number"
              value={edit.pay_date}
              onChange={(e) => handleChange('pay_date', e.target.value)}
              className="border dark:border-gray-700 dark:bg-black dark:text-white px-3 py-2 rounded w-full text-sm"
            />
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-4">
          <div className="space-y-1">
            <label className="font-medium dark:text-white">Salary Components</label>
            {Object.entries(edit.salary_components).map(([key, val]) => (
              <div key={key} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={val}
                  onChange={() => handleComponentToggle(key)}
                />
                <span className="capitalize dark:text-white">{key}</span>
              </div>
            ))}
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="font-medium dark:text-white">Enable TDS Deduction</span>
              <input
                type="checkbox"
                checked={edit.enable_tds}
                onChange={() => handleToggle('enable_tds')}
              />
            </div>
            <div className="flex items-center justify-between">
              <span className="font-medium dark:text-white">Auto Email Payslips</span>
              <input
                type="checkbox"
                checked={edit.auto_payslip_email}
                onChange={() => handleToggle('auto_payslip_email')}
              />
            </div>
          </div>
        </div>

        <div className="flex justify-end gap-2 pt-4">
          <button
            onClick={handleReset}
            className="border border-gray-300 px-4 py-2 dark:text-white dark:hover:bg-gray-800 rounded text-sm hover:bg-gray-50"
          >
            Reset
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded text-sm"
          >
            Save Settings
          </button>
        </div>
      </div>
    </PayrollLayout>
  );
}
